import React from 'react';


export  const languageContext=  React.createContext()
export  const LanguageProvider=languageContext.Provider